module.exports = __webpack_public_path__ + "static/media/azure_brandmark.2e706e77.svg";